/* eslint-disable react/jsx-closing-tag-location */
import { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import ListGroup from 'react-bootstrap/ListGroup';
import ListGroupItem from 'react-bootstrap/ListGroupItem';
import { connect } from 'react-redux';

import * as actions from '../store/actions';
import * as URL from '../../../lib/router/url';
import Can from '../../permissions/abilities/Can';
import Panel from '../../core/components/panel';
import { unixToDateTimeString } from '../../core/utils/date';

// interface PanelLastActionsStatProps {
//   lastRegisteredUsers?: unknown[]
//   getLastUsers?(...args: unknown[]): unknown
// }

class PanelLastActionsStat extends PureComponent<PanelLastActionsStatProps> {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    this.setState({ loading: false }, async () => {
      await this.props.getLastUsers();

      this.setState({ loading: false });
    });
  };

  render() {
    const { lastRegisteredUsers } = this.props;
    const { loading } = this.state;

    return (
      <Can do='available' on='show.last.event'>
        { can => (
          <Panel loading={ can && loading }>
            <section className='dashboard_panel no_right_margin'>
              <h2 className='dashboard_title'>Последние события</h2>

              <div className='dashboard_scroll-block'>
                <ListGroup>
                  { lastRegisteredUsers?.map(user => (
                    <ListGroupItem key={ user.id }>
                      <span className='float-end'>
                        <strong>{ unixToDateTimeString(user.createdAt) }</strong>
                      </span>

                      <div>
                        Пользователь <Link to={ `${ URL.URL_USERS_VIEW_ONE }/${ user.id }` }>
                          { user.lastName }&nbsp;{ user.firstName }&nbsp;{ user.middleName }
                        </Link> зарегистрировался в системе
                      </div>
                      <div>
                        Телефон: <span><b> { user.phone }</b></span>
                      </div>
                      <div>
                        Партнёр: <span><b> { user.partnerName }</b></span>
                      </div>
                      <div>
                        Статус: <span className='text-warning'>
                          <b> { user.statusRefValueName }</b>
                        </span>
                      </div>
                    </ListGroupItem>
                  )) }
                </ListGroup>
              </div>
            </section>
          </Panel>
        ) }
      </Can>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lastRegisteredUsers: state.dashboard?.lastRegisteredUsers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getLastUsers: payload => dispatch(actions.getLastUsers(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PanelLastActionsStat);
